var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { staticClass: "sidebar float-md-none float-lg-right float-xl-right" },
    [
      _c(
        "div",
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                { staticClass: "d-flex align-items-center" },
                [
                  _c("b-col", { staticClass: "col-12" }, [
                    _c("h4", { staticClass: "h5 font-weight-bold" }, [
                      _vm._v("Übersicht Ihrer Konfigur­ation")
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-none d-lg-block d-xl-block" },
            [
              _c(
                "b-container",
                { staticClass: "overview " },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "image-container" },
                        [
                          _c("CarImage", {
                            staticClass: "rounded cd-car-image",
                            attrs: { imageUrl: _vm.carImageUrl }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c(
                          "h5",
                          {
                            staticClass:
                              "cd-model-description cd-primary-sub-color font-weight-bold"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.maker ? _vm.maker.label : "") +
                                " " +
                                _vm._s(_vm.model ? _vm.model.label : "") +
                                " "
                            )
                          ]
                        ),
                        _c("span", { staticClass: "cd-engine-label" }, [
                          _vm._v(_vm._s(_vm.engine ? _vm.engine.label : ""))
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-container",
                { staticClass: "p-4" },
                [
                  _c(
                    "b-row",
                    { staticClass: "d-flex justify-content-between" },
                    [
                      _c("span", [_vm._v("Herstellerlistenpreis")]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatCurrency")(
                              _vm.calculatedBasePrice[_vm.pricing]
                            )
                          ) + " €"
                        )
                      ])
                    ]
                  ),
                  _c(
                    "b-row",
                    { staticClass: "d-flex justify-content-between" },
                    [
                      _c("span", [_vm._v("Sonderausstattung")]),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("formatCurrency")(_vm.priceOfExtras)) +
                            " €"
                        )
                      ])
                    ]
                  ),
                  _c(
                    "b-row",
                    { staticClass: "d-flex justify-content-between" },
                    [
                      _c("span", [_vm._v("Gesamtlistenpreis")]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatCurrency")(
                              _vm.calculatedTotalPrice[_vm.pricing]
                            )
                          ) + " €"
                        )
                      ])
                    ]
                  ),
                  _vm.calculatedSavings > 0
                    ? _c(
                        "b-row",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c("span", [_vm._v("Ersparnis")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatCurrency")(_vm.calculatedSavings)
                              ) + " €"
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "b-row",
                    { staticClass: "d-flex justify-content-between" },
                    [
                      _c("span", [_vm._v("Endpreis")]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatCurrency")(
                              _vm.calculatedIntermediatePrice
                            )
                          ) + " €"
                        )
                      ])
                    ]
                  ),
                  _vm.condition && _vm.condition.provision_costs
                    ? _c(
                        "b-row",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c("span", [_vm._v("Bereitstellungskosten")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatCurrency")(
                                  _vm.condition
                                    ? _vm.condition.provision_costs
                                    : 0
                                )
                              ) + " €"
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("hr", { staticClass: "cd-divider" }),
              _c(
                "b-container",
                { staticClass: "p-4 d-none d-lg-block d-xl-block" },
                [
                  _c(
                    "b-row",
                    { staticClass: "d-flex justify-content-between" },
                    [
                      _c("h3", { staticClass: "cd-final-price" }, [
                        _vm._v("Unser Preis")
                      ]),
                      _c(
                        "span",
                        { staticClass: "cd-final-price cd-primary-color" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatCurrency")(
                                _vm.calculatedDiscountedPrice
                              )
                            ) + " €"
                          )
                        ]
                      )
                    ]
                  ),
                  _c("b-row", [_c("span", [_vm._v(_vm._s(_vm.pricingHint))])])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "d-block d-xs-block d-sm-block d-md-block d-lg-none d-xl-none"
            },
            [
              _c(
                "b-container",
                {
                  staticClass: "mb-3 ",
                  staticStyle: { background: "#fff" },
                  attrs: { fluid: "" }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "col-2 image-container" },
                        [
                          _c("CarImage", {
                            staticClass: "rounded cd-car-image",
                            attrs: { imageUrl: _vm.carImageUrl }
                          })
                        ],
                        1
                      ),
                      _c("b-col", { staticClass: "bestelluebersicht" }, [
                        _c("h5", [_vm._v("Bestellübersicht")]),
                        _c("span", [_vm._v("1 Fahrzeug")])
                      ]),
                      _c(
                        "b-col",
                        { staticClass: "col-2 d-flex justify-content-end p-0" },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.collapse-1",
                                  modifiers: { "collapse-1": true }
                                }
                              ],
                              staticClass: "toggle collapsed"
                            },
                            [
                              _c("b-icon", {
                                staticClass: "when-closed",
                                attrs: { icon: "arrow-down-circle-fill" }
                              }),
                              _c("b-icon", {
                                staticClass: "when-open",
                                attrs: { icon: "arrow-up-circle-fill" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-container",
                { staticStyle: { background: "#fff" } },
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c(
                          "h5",
                          {
                            staticClass:
                              "cd-model-description cd-primary-sub-color font-weight-bold"
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.maker ? _vm.maker.label : "") +
                                " " +
                                _vm._s(_vm.model ? _vm.model.label : "")
                            )
                          ]
                        ),
                        _c("span", { staticClass: "cd-engine-label" }, [
                          _vm._v(_vm._s(_vm.engine ? _vm.engine.label : ""))
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-collapse",
                { attrs: { id: "collapse-1" } },
                [
                  _c("hr", { staticClass: "cd-divider" }),
                  _c(
                    "b-container",
                    { staticClass: "p-4" },
                    [
                      _c(
                        "b-row",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c("span", [_vm._v("Herstellerlistenpreis")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatCurrency")(
                                  _vm.calculatedBasePrice[_vm.pricing]
                                )
                              ) + " €"
                            )
                          ])
                        ]
                      ),
                      _c(
                        "b-row",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c("span", [_vm._v("Sonderausstattung")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatCurrency")(_vm.priceOfExtras)
                              ) + " €"
                            )
                          ])
                        ]
                      ),
                      _c(
                        "b-row",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c("span", [_vm._v("Gesamtlistenpreis")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatCurrency")(
                                  _vm.calculatedTotalPrice[_vm.pricing]
                                )
                              ) + " €"
                            )
                          ])
                        ]
                      ),
                      _vm.calculatedSavings > 0
                        ? _c(
                            "b-row",
                            { staticClass: "d-flex justify-content-between" },
                            [
                              _c("span", [_vm._v("Ersparnis")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatCurrency")(
                                      _vm.calculatedSavings
                                    )
                                  ) + " €"
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "b-row",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c("span", [_vm._v("Endpreis")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatCurrency")(
                                  _vm.calculatedIntermediatePrice
                                )
                              ) + " €"
                            )
                          ])
                        ]
                      ),
                      _vm.condition && _vm.condition.provision_costs
                        ? _c(
                            "b-row",
                            { staticClass: "d-flex justify-content-between" },
                            [
                              _c("span", [_vm._v("Bereitstellungskosten")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatCurrency")(
                                      _vm.condition
                                        ? _vm.condition.provision_costs
                                        : 0
                                    )
                                  ) + " €"
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("hr", { staticClass: "cd-divider" }),
                  _c(
                    "b-container",
                    { staticClass: "p-4" },
                    [
                      _c(
                        "b-row",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c("h3", { staticClass: "cd-final-price" }, [
                            _vm._v("Unser Preis")
                          ]),
                          _c(
                            "span",
                            { staticClass: "cd-final-price cd-primary-color" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatCurrency")(
                                    _vm.calculatedDiscountedPrice
                                  )
                                ) + " €"
                              )
                            ]
                          )
                        ]
                      ),
                      _c("b-row", [
                        _c("span", [_vm._v(_vm._s(_vm.pricingHint))])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("hr", { staticClass: "cd-divider" }),
          _c(
            "b-container",
            {
              staticClass:
                "cd-price-info d-none d-sm-none d-md-none d-lg-block",
              attrs: { "p-2": "" }
            },
            [
              _c(
                "b-container",
                { attrs: { "p-2": "" } },
                [_c("b-row", [_c("b-col", [_c("SidebarButton")], 1)], 1)],
                1
              ),
              _c(
                "b-container",
                [
                  _c(
                    "b-row",
                    { staticClass: "cd-offer-container" },
                    [
                      _c("b-col", { staticClass: "text-center" }, [
                        _vm.showOfferLink || _vm.contactData
                          ? _c(
                              "a",
                              {
                                staticClass: "cd-offer-link",
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.downloadOfferPdf()
                                  }
                                }
                              },
                              [_vm._v("Konfiguration drucken")]
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }